import { useFlags } from 'launchdarkly-react-client-sdk';

export interface FeatureFlags {
    ldFlagLandDevelopment: boolean;
    ldFlagUploadedProForma: boolean;
    ldFlagNavbarV2: boolean;
    ldFlagVendorRevampQ22026: boolean;
}

export const useTypedFlags = (): FeatureFlags => useFlags<FeatureFlags>();
